









































































import Vue from "vue";

import TwoPlayer from "@/components/TwoPlayer.vue";
import ThreePlayer from "@/components/ThreePlayer.vue";
import FourPlayer from "@/components/FourPlayer.vue";
import { Random } from "@/scripts/random";
import { hints, cards } from "@/consts/consts";

export default Vue.extend({
  components: {
    TwoPlayer,
    ThreePlayer,
    FourPlayer
  },
  data() {
    return {
      hints: Array<{ msg: string; showable: boolean; used: boolean }>(),
      cards: Array<{ number: number; color: string }>(),
      players: 2,
      seed: Math.floor(Math.random() * Math.floor(10000))
    };
  },
  computed: {
    enableHints(): Array<{ msg: string; showable: boolean }> {
      return this.hints.filter(h => h.showable);
    },
    usedHints(): Array<{ msg: string; used: boolean }> {
      return this.hints.filter(h => h.used);
    },
    invalidSeed(): boolean {
      return !(this.seed > 0 && this.seed <= 99999);
    }
  },
  methods: {
    init() {
      const random = new Random(this.seed * this.players);

      this.initHint(random);
      this.initCard(random);
    },
    initHint(random: Random) {
      this.hints = hints.map(h => {
        return { msg: h, showable: false, used: false };
      });
      Random.shuffle(random, this.hints);
      this.hints = this.hints.map((h, i) => {
        h.showable = i <= 5;
        return h;
      });
    },
    initCard(random: Random) {
      this.cards = cards.map(c => c);
      Random.shuffle(random, this.cards);
    },
    useHint(index: number) {
      if (this.hints.length <= index || this.hints[index].used) return;
      let showOnce = false;
      this.hints = this.hints.map((h, i, hints) => {
        if (i == index) h.used = true;
        if (!showOnce && !h.showable && hints[i - 1].showable) {
          h.showable = true;
          showOnce = true;
        }
        return h;
      });
    }
  },
  mounted() {
    this.init();
  }
});
